// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3l0tp","dragIcon":"SortableItem_dragIcon__3uCAr","disabled":"SortableItem_disabled__1PunE"};